import { UnknownBlueprint } from '../types';

export const u0 = (inBlueprint: UnknownBlueprint): [UnknownBlueprint, boolean] => {
	console.log('schema-update:process-update:0:unsupported');
	inBlueprint.schemaVersion = 0;
	return [inBlueprint, false];
};
